import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface CategoryTabsProps {
  activeSlug: string;
  basePath?: string;
}

export default function CategoryTabs({ activeSlug, basePath = '/category' }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`${basePath}/${cat.slug}`}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-white'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200/70 hover:text-foreground-800'
          }`}
        >
          <i className={`${cat.icon} text-base`}></i>
          {cat.name}
        </Link>
      ))}
    </div>
  );
}